<selected-billets-panel [count]="selectedBoletos.length" [total]="totalSelecionado"
    [disabled]="selectedBoletos.length === 0" (confirm)="confirmar()">
</selected-billets-panel>

<mat-card class="create-agreement-card">
    <div class="container-fluid marginHeader">

        <!-- Filtro -->
        <div class="filter-section card mb-3">

            <div class="card-body">
                <form [formGroup]="filterForm">
                    <div class="row">
                        <div class="col-sm-4">

                            <div class="form-check">
                                <input class="form-check-input" value="duedateFilter" type="radio" checked="true"
                                    formControlName="filterDateName" name="filterDateName" id="duedateFilter" />
                                <label class="form-check-label" for="duedateFilter"> Data Vencimento </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" value="receiptdateFilter" type="radio"
                                    name="filterDateName" formControlName="filterDateName" id="receiptdateFilter" />
                                <label class="form-check-label" for="receiptdateFilter"> Data Recebimento </label>
                            </div>
                        </div>

                        <div class="col-sm-6">

                            <div class="form-check">
                                <input class="form-check-input" value="1" type="radio" checked="true"
                                    formControlName="isInternalReceipt" name="isInternalReceipt"
                                    id="isInternalReceiptTrue" />
                                <label class="form-check-label" for="isInternalReceiptTrue"> Recebimento Interno
                                    (7Edu-Financeiro) </label>
                            </div>

                            <div class="form-check">
                                <input class="form-check-input" value="0" type="radio" name="isInternalReceipt"
                                    formControlName="isInternalReceipt" id="isInternalReceiptFalse" />
                                <label class="form-check-label" for="isInternalReceiptFalse"> Recebimento Externo
                                    (Cobradora)
                                </label>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Data Início</mat-label>
                                <input matInput [matDatepicker]="startDatePicker" formControlName="startDate" />
                                <mat-datepicker-toggle matSuffix [for]="startDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #startDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Data Fim</mat-label>
                                <input matInput [matDatepicker]="endDatePicker" formControlName="endDate" />
                                <mat-datepicker-toggle matSuffix [for]="endDatePicker"></mat-datepicker-toggle>
                                <mat-datepicker #endDatePicker></mat-datepicker>
                            </mat-form-field>
                        </div>

                        <div class="col-md-2">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Empresa</mat-label>
                                <mat-select formControlName="companyId">
                                    <mat-option *ngFor="let company of companies" [value]="company.companyId">
                                        {{ company.shortName || company.name }}
                                    </mat-option>
                                </mat-select>
                            </mat-form-field>
                        </div>

                        <div class="col-md-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Recibo</mat-label>
                                <input matInput type="text" formControlName="receiptCode"
                                    placeholder="Número do recibo" />
                            </mat-form-field>
                        </div>

                        <div class="col-md-3">
                            <button mat-flat-button color="primary" type="button" (click)="buscar()">
                                <i class="fas fa-search"></i>
                                Buscar
                            </button>
                        </div>
                    </div>


                </form>
            </div>
        </div>

        <!-- Tabela de Boletos -->
        <div class="boletos-section card">
            <div class="card-header">
                <div class="d-flex justify-content-between align-items-center">
                    <h5>Boletos Disponíveis</h5>
                    <span class="badge badge-info">{{ filteredBoletos.length }} boletos</span>
                </div>
            </div>

            <div class="card-body table-responsive">
                <div class="row">
                    <div class="col-10">
                        <div class="mb-3">
                            <mat-form-field appearance="outline" class="w-100">
                                <mat-label>Pesquisar boletos</mat-label>
                                <input matInput type="text" [(ngModel)]="tableFilter"
                                    (ngModelChange)="applyTableFilter()"
                                    placeholder="Número, aluno, escola, série, valor, vencimento" />
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="col-2">
                        <label for="itemSelectedSummary" class="summary-label">Visualizar Selecionados</label>
                        <input id="itemSelectedSummary" (change)="filterOnlySelected()" type="checkbox"
                            [checked]="viewOnlySelected" />
                    </div>

                </div>
                <table class="table table-hover table-sm">
                    <thead>
                        <tr>
                            <th style="width: 50px">
                                <input type="checkbox" [checked]="isAllSelected()" (change)="toggleSelectAll()" />
                            </th>
                            <th (click)="sortBy('dataVencimento')" class="sortable-column">
                                Vencimento
                                <i *ngIf="sortField === 'dataVencimento'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                            <th (click)="sortBy('dataPagamento')" class="sortable-column">
                                Recebimento
                                <i *ngIf="sortField === 'dataPagamento'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                            <th (click)="sortBy('numeroCarne')" class="sortable-column">
                                Código Carne
                                <i *ngIf="sortField === 'numeroCarne'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                            <th (click)="sortBy('nomeAluno')" class="sortable-column">
                                Aluno
                                <i *ngIf="sortField === 'nomeAluno'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>

                            <th (click)="sortBy('nomeEscola')" class="sortable-column">
                                Escola
                                <i *ngIf="sortField === 'nomeEscola'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                            <th class="text-right">
                                Nominal
                            </th>
                            <th class="text-right">
                                Juros
                            </th>
                            <th class="text-right">
                                Multa
                            </th>
                            <th class="text-right">
                                Encargos
                            </th>
                            <th (click)="sortBy('valorPago')" class="sortable-column">
                                Recebido
                            </th>
                            <th (click)="sortBy('description')" class="sortable-column">
                                Descrição
                                <i *ngIf="sortField === 'description'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                            <th (click)="sortBy('numeroRecibo')" class="sortable-column">
                                Recibo
                                <i *ngIf="sortField === 'numeroRecibo'" class="fas"
                                    [ngClass]="{'fa-sort-up': sortDirection === 'asc', 'fa-sort-down': sortDirection === 'desc'}"></i>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let boleto of displayedBoletos" [class.table-active]="boleto.selected"
                            (click)="onSelectBoleto(boleto)">
                            <td>
                                <input type="checkbox" [checked]="boleto.selected" />
                            </td>
                            <td>{{ boleto.dataVencimento | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ boleto.dataPagamento | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ boleto.numeroCarne }}</td>
                            <td>{{ boleto.nomeAluno }}</td>
                            <td>{{ boleto.nomeEscola }}</td>
                            <td class="text-right">R$ {{ boleto.valorNominal | number: '1.2-2' }}</td>
                            <td class="text-right">R$ {{ boleto.juros | number: '1.2-2' }}</td>
                            <td class="text-right">R$ {{ boleto.multa | number: '1.2-2' }}</td>
                            <td class="text-right">R$ {{ (boleto.honorarios+boleto.correcaoMonetaria+boleto.desconto) |
                                number: '1.2-2'
                                }}</td>
                            <td class="text-right">R$ {{ boleto.valorPago | number: '1.2-2' }}</td>
                            <td>{{ boleto.description }}</td>
                            <td>{{ boleto.numeroRecibo }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <!-- Resumo -->
            <div class="card-footer">
                <div class="summary-row">
                    <div>
                        <span class="summary-label">Boletos selecionados:</span>
                        <strong>{{ selectedBoletos.length }}</strong>
                    </div>
                    <div class="text-right">
                        <span class="summary-label">Total:</span>
                        <strong class="summary-total">R$ {{ totalSelecionado | number: '1.2-2' }}</strong>
                    </div>
                </div>
                <div class="d-flex justify-content-between align-items-center mt-3">
                    <div class="form-inline">
                        <label class="mr-2">Itens por página:</label>
                        <select class="form-control" (change)="setPageSize($event.target.value)">
                            <option *ngFor="let size of pageSizeOptions" [value]="size">{{ size }}</option>
                        </select>
                    </div>
                    <div class="d-flex align-items-center">
                        <button mat-stroked-button color="primary" type="button" [disabled]="pageIndex === 0"
                            (click)="previousPage()">
                            Anterior
                        </button>
                        <span class="mx-3">Página {{ pageIndex + 1 }} de {{ totalPages }}</span>
                        <button mat-stroked-button color="primary" type="button"
                            [disabled]="pageIndex >= totalPages - 1" (click)="nextPage()">
                            Próxima
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Botões de Ação -->
        <div class="actions-section mt-4">
            <button mat-button class="btn-cancel" type="button">
                <i class="fas fa-times"></i>
                Cancelar
            </button>
        </div>
    </div>
</mat-card>

<loader></loader>